import * as React from "react";
const PublicInformationIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 56 56",
  "aria-hidden": "true",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#public-information_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.021 4h-.042A7.979 7.979 0 0 0 20 11.979v17.042A7.979 7.979 0 0 0 27.979 37h.042A7.979 7.979 0 0 0 36 29.021V11.979A7.979 7.979 0 0 0 28.021 4Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42 28.5a1.5 1.5 0 1 0-3 0 11 11 0 1 1-22 0 1.5 1.5 0 1 0-3 0 13.996 13.996 0 0 0 12 13.846V48h-4a2.02 2.02 0 0 0-1.755 3.001 1.915 1.915 0 0 0 1.733.999H34a2.02 2.02 0 0 0 1.755-3.002A1.915 1.915 0 0 0 34.022 48H30v-5.665A14.023 14.023 0 0 0 42 28.5Z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "public-information_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h56v56H0z"
}))));
export default PublicInformationIcon;